"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldSubForm = exports.ModelMutatorSubForm = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var id_1 = require("../../../id");
var collection_base_1 = require("../collection.base");
var collection_field_1 = require("../collection.field");
var ModelMutatorSubForm = /** @class */ (function (_super) {
    tslib_1.__extends(ModelMutatorSubForm, _super);
    function ModelMutatorSubForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new subForm instance
     * @param id (Optional) instanceId
     * @returns the instanceId of the instance created.
     */
    ModelMutatorSubForm.prototype.create = function (id) {
        if (id == null || id === '') {
            id = id_1.IkeId.generate(10);
        }
        var instanceIds = this.getStateValue();
        if (instanceIds.indexOf(id) !== -1) {
            throw new Error("Subform instance id must be unique: ".concat(id));
        }
        instanceIds.push(id);
        this.state.setFieldValue(this.field.id, instanceIds);
        return id;
    };
    ModelMutatorSubForm.prototype.clear = function () {
        for (var _i = 0, _a = this.field.value; _i < _a.length; _i++) {
            var instance = _a[_i];
            this.clearInstance(instance);
        }
        this.state.setFieldValue(this.field.id, null);
    };
    ModelMutatorSubForm.prototype.remove = function (instanceId) {
        var instanceIds = this.getStateValue();
        var index = instanceIds.indexOf(instanceId);
        if (index === -1) {
            throw new Error("Cannot remove subform. Instance \"".concat(instanceId, "\" is missing from subform \"").concat(this.field.id, "\""));
        }
        this.clearInstance(this.field.value[index]);
        instanceIds.splice(index, 1);
        delete this.field.instances[instanceId];
        this.field.collection.state.setFieldValue(this.field.id, instanceIds);
    };
    ModelMutatorSubForm.prototype.getStateValue = function () {
        var stateValue = this.field.stateValue;
        if (Array.isArray(stateValue)) {
            return stateValue.slice();
        }
        return [];
    };
    ModelMutatorSubForm.prototype.clearInstance = function (instance) {
        for (var _i = 0, _a = instance.schema.fields; _i < _a.length; _i++) {
            var fieldSchema = _a[_i];
            if (instance.hasField(fieldSchema.id)) {
                instance.getField(fieldSchema.id).Mutator.clear();
            }
        }
    };
    /**
     * Copies all subform instances from the target into this subform.
     *
     * @param from Subform to copy from.
     */
    ModelMutatorSubForm.prototype.copy = function (from) {
        var hasCopied = true;
        for (var _i = 0, _a = from.value; _i < _a.length; _i++) {
            var instance = _a[_i];
            var createdInstanceId = this.create();
            var newInstance = this.field.getInstance(createdInstanceId);
            var fieldCopied = this.copyFields(instance, newInstance);
            if (!fieldCopied) {
                hasCopied = false;
            }
        }
        return hasCopied;
    };
    /**
    * Copies a specific subform instance from the target into this subform.
    *
    * @param from Subform to copy from.
    * @param instanceId Specific instance to copy.
    * @param linkId Whether the new instance should have the same instanceId as the original.
    */
    ModelMutatorSubForm.prototype.copyInstance = function (from, instanceId, linkId) {
        var instance = from.getInstance(instanceId);
        if (instance == null) {
            return null;
        }
        var newInstanceId = this.create(linkId ? instanceId : null);
        var newInstance = this.field.getInstance(newInstanceId);
        var hasCopied = this.copyFields(instance, newInstance);
        return hasCopied ? newInstance : null;
    };
    ModelMutatorSubForm.prototype.copyFields = function (from, to) {
        var hasCopied = true;
        for (var _i = 0, _a = from.schema.fields; _i < _a.length; _i++) {
            var schemaField = _a[_i];
            var field = from.getField(schemaField.id);
            var newField = to.getField(schemaField.id);
            var fieldCopied = newField.Mutator.copy(field);
            if (!fieldCopied) {
                hasCopied = false;
            }
        }
        return hasCopied;
    };
    return ModelMutatorSubForm;
}(collection_field_1.ModelMutator));
exports.ModelMutatorSubForm = ModelMutatorSubForm;
var CollectionModelFieldSubForm = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelFieldSubForm, _super);
    function CollectionModelFieldSubForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.instances = {};
        return _this;
    }
    CollectionModelFieldSubForm.isSubFormField = function (f) {
        return f.schema.type === CollectionModelFieldSubForm.TYPE;
    };
    Object.defineProperty(CollectionModelFieldSubForm.prototype, "Mutator", {
        get: function () {
            if (this._Mutator == null) {
                this._Mutator = new ModelMutatorSubForm(this);
            }
            return this._Mutator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldSubForm.prototype, "value", {
        get: function () {
            var stateValue = this.stateValue;
            if (!Array.isArray(stateValue)) {
                return [];
            }
            var output = [];
            for (var _i = 0, stateValue_1 = stateValue; _i < stateValue_1.length; _i++) {
                var instanceId = stateValue_1[_i];
                output.push(this.getOrCreateInstance(instanceId));
            }
            return output;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldSubForm.prototype.getOrCreateInstance = function (instanceId) {
        var existing = this.instances[instanceId];
        if (existing == null) {
            existing = this.instances[instanceId] = new collection_base_1.CollectionModelFieldSubFormInstance(this, instanceId, this.schema);
        }
        return existing;
    };
    CollectionModelFieldSubForm.prototype.getInstance = function (instanceId) {
        var stateValue = this.stateValue;
        if (!Array.isArray(stateValue)) {
            return null;
        }
        var hasInstance = stateValue.indexOf(instanceId) > -1;
        if (hasInstance) {
            return this.getOrCreateInstance(instanceId);
        }
        return null;
    };
    CollectionModelFieldSubForm.prototype.mustGetInstance = function (instanceId) {
        var instance = this.getInstance(instanceId);
        if (!instance) {
            throw new Error("mustGetInstance: failed to get instance with id ".concat(instanceId));
        }
        return instance;
    };
    CollectionModelFieldSubForm.prototype.hasValue = function () {
        var stateValue = this.stateValue;
        if (!Array.isArray(stateValue)) {
            return false;
        }
        return this.stateValue.length > 0;
    };
    CollectionModelFieldSubForm.TYPE = core_api_1.IkeFieldType.FORM;
    return CollectionModelFieldSubForm;
}(collection_field_1.CollectionModelField));
exports.CollectionModelFieldSubForm = CollectionModelFieldSubForm;
//# sourceMappingURL=form.field.js.map